import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, tap } from 'rxjs';
import { DateTime } from 'luxon';
import { Valid } from 'luxon/src/_util';
import { environment } from '../../../environments/environment';
import { CreateGraphCollectionRequest, IGraphCollection, UpdateGraphCollectionRequest } from '../../model/dto/graph-collection.type';
import { IGraphCollectionsType } from '../../model/dto/graph-collections.type';

@Injectable({ providedIn: 'root' })
export class GraphCollectionApiService {
    public graphCollectionSaved$ = new Subject<void>();

    constructor(private readonly httpClient: HttpClient) { }

    public getGraphCollection(
        begin: DateTime<Valid>,
        end: DateTime<Valid>,
        type: IGraphCollectionsType,
        portfolioId: string,
        siteId: string,
    ): Observable<IGraphCollection[]> {
        const params = { type, begin: begin.toISO(), end: end.toISO(), portfolioId, siteId };

        return this.httpClient.get<IGraphCollection[]>(`${environment.backendUrl}/graph-collection/v1`, {
            params: params,
        });
    }

    public getAllGraphCollections(): Observable<IGraphCollection[]> {
        return this.httpClient.get<IGraphCollection[]>(`${environment.backendUrl}/graph-collection/v1`);
    }

    public getGraphCollectionById(
        graphCollectionId: string,
        begin: DateTime<Valid>,
        end: DateTime<Valid>,
        portfolioId: string,
        siteId: string,
    ): Observable<IGraphCollection> {
        return this.httpClient.get<IGraphCollection>(
            `${environment.backendUrl}/graph-collection/v1/${graphCollectionId}`,
            {
                params: { begin: begin.toISO(), end: end.toISO(), portfolioId, siteId },
            },
        );
    }

    public createGraphCollection(data: CreateGraphCollectionRequest): Observable<null> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.httpClient
            .post<null>(`${environment.backendUrl}/graph-collection/v1`, JSON.stringify(data), {
            headers: headers,
        }).pipe(tap(() => {
            this.graphCollectionSaved$.next();
        }));
    }

    public updateGraphCollection(id: string, data: UpdateGraphCollectionRequest): Observable<null> {
        return this.httpClient.patch<null>(`${environment.backendUrl}/graph-collection/v1/${id}`, data).pipe(tap(() => {
            this.graphCollectionSaved$.next();
        }));
    }

    public deleteGraphCollection(id: string): Observable<void> {
        return this.httpClient.delete<void>(`${environment.backendUrl}/graph-collection/v1/${id}`).pipe(tap(() => {
            this.graphCollectionSaved$.next();
        }));
    }
}
